import { Text } from '../Ant';
import { SectionHeadingRow } from '../../assets/styles/components/settingsPopover.styled';

interface IListSectionHeadingProperties {
  title: string;
  className?: string;
}

const ListSectionHeading = ({ title, className }: Readonly<IListSectionHeadingProperties>) => (
  <SectionHeadingRow className={`list-section-heading ${className ?? ''}`.trim()}>
    <span className="section-heading-rule" />
    <Text $fontsize="12px" $lineheight="16px" $weight={500} $color="description">
      {title}
    </Text>
    <span className="section-heading-rule" />
  </SectionHeadingRow>
);

export default ListSectionHeading;
